
export interface HalfTimeStats {
  leading: {
    total: { matches: number; winFt: number; drawFt: number; lossFt: number };
    home: { matches: number; winFt: number; drawFt: number; lossFt: number };
    away: { matches: number; winFt: number; drawFt: number; lossFt: number };
  };
  drawing: {
    total: { matches: number; winFt: number; drawFt: number; lossFt: number };
    home: { matches: number; winFt: number; drawFt: number; lossFt: number };
    away: { matches: number; winFt: number; drawFt: number; lossFt: number };
  };
  losing: {
    total: { matches: number; winFt: number; drawFt: number; lossFt: number };
    home: { matches: number; winFt: number; drawFt: number; lossFt: number };
    away: { matches: number; winFt: number; drawFt: number; lossFt: number };
  };
}

export const calculateDetailedHalfTimeStats = (matches: any[]): HalfTimeStats => {
  const stats: HalfTimeStats = {
    leading: {
      total: { matches: 0, winFt: 0, drawFt: 0, lossFt: 0 },
      home: { matches: 0, winFt: 0, drawFt: 0, lossFt: 0 },
      away: { matches: 0, winFt: 0, drawFt: 0, lossFt: 0 }
    },
    drawing: {
      total: { matches: 0, winFt: 0, drawFt: 0, lossFt: 0 },
      home: { matches: 0, winFt: 0, drawFt: 0, lossFt: 0 },
      away: { matches: 0, winFt: 0, drawFt: 0, lossFt: 0 }
    },
    losing: {
      total: { matches: 0, winFt: 0, drawFt: 0, lossFt: 0 },
      home: { matches: 0, winFt: 0, drawFt: 0, lossFt: 0 },
      away: { matches: 0, winFt: 0, drawFt: 0, lossFt: 0 }
    }
  };

  matches.forEach(match => {
    const homeGoals = parseInt(match.HTHG) || 0;
    const awayGoals = parseInt(match.HTAG) || 0;
    const ftHomeGoals = parseInt(match.FTHG) || 0;
    const ftAwayGoals = parseInt(match.FTAG) || 0;

    // For each match, we need to update stats for both teams
    // First team (home team's perspective)
    if (homeGoals > awayGoals) {
      // Leading at HT
      stats.leading.total.matches++;
      stats.leading.home.matches++;
      
      if (ftHomeGoals > ftAwayGoals) {
        stats.leading.total.winFt++;
        stats.leading.home.winFt++;
      } else if (ftHomeGoals === ftAwayGoals) {
        stats.leading.total.drawFt++;
        stats.leading.home.drawFt++;
      } else {
        stats.leading.total.lossFt++;
        stats.leading.home.lossFt++;
      }
    } else if (homeGoals === awayGoals) {
      // Drawing at HT
      stats.drawing.total.matches++;
      stats.drawing.home.matches++;
      
      if (ftHomeGoals > ftAwayGoals) {
        stats.drawing.total.winFt++;
        stats.drawing.home.winFt++;
      } else if (ftHomeGoals === ftAwayGoals) {
        stats.drawing.total.drawFt++;
        stats.drawing.home.drawFt++;
      } else {
        stats.drawing.total.lossFt++;
        stats.drawing.home.lossFt++;
      }
    } else {
      // Losing at HT
      stats.losing.total.matches++;
      stats.losing.home.matches++;
      
      if (ftHomeGoals > ftAwayGoals) {
        stats.losing.total.winFt++;
        stats.losing.home.winFt++;
      } else if (ftHomeGoals === ftAwayGoals) {
        stats.losing.total.drawFt++;
        stats.losing.home.drawFt++;
      } else {
        stats.losing.total.lossFt++;
        stats.losing.home.lossFt++;
      }
    }

    // Second team (away team's perspective)
    if (awayGoals > homeGoals) {
      // Away team leading at HT
      stats.leading.total.matches++;
      stats.leading.away.matches++;
      
      if (ftAwayGoals > ftHomeGoals) {
        stats.leading.total.winFt++;
        stats.leading.away.winFt++;
      } else if (ftAwayGoals === ftHomeGoals) {
        stats.leading.total.drawFt++;
        stats.leading.away.drawFt++;
      } else {
        stats.leading.total.lossFt++;
        stats.leading.away.lossFt++;
      }
    } else if (awayGoals === homeGoals) {
      // Away team drawing at HT
      stats.drawing.total.matches++;
      stats.drawing.away.matches++;
      
      if (ftAwayGoals > ftHomeGoals) {
        stats.drawing.total.winFt++;
        stats.drawing.away.winFt++;
      } else if (ftAwayGoals === ftHomeGoals) {
        stats.drawing.total.drawFt++;
        stats.drawing.away.drawFt++;
      } else {
        stats.drawing.total.lossFt++;
        stats.drawing.away.lossFt++;
      }
    } else {
      // Away team losing at HT
      stats.losing.total.matches++;
      stats.losing.away.matches++;
      
      if (ftAwayGoals > ftHomeGoals) {
        stats.losing.total.winFt++;
        stats.losing.away.winFt++;
      } else if (ftAwayGoals === ftHomeGoals) {
        stats.losing.total.drawFt++;
        stats.losing.away.drawFt++;
      } else {
        stats.losing.total.lossFt++;
        stats.losing.away.lossFt++;
      }
    }
  });

  return stats;
};
